import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { Badge } from "@/components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

export function ApprovalHierarchy() {
  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle>Approval Hierarchy</CardTitle>
          <CardDescription>
            Organizational structure for bill approval workflow
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            {/* Senior Manager */}
            <div className="flex items-center gap-4 p-4 border rounded-lg">
              <Avatar>
                <AvatarFallback>SM</AvatarFallback>
              </Avatar>
              <div className="flex-1">
                <div className="font-semibold">Senior Manager</div>
                <div className="text-sm text-muted-foreground">Approval limit: Unlimited</div>
              </div>
              <Badge>Level 3</Badge>
            </div>

            {/* Billing Manager */}
            <div className="ml-8 flex items-center gap-4 p-4 border rounded-lg">
              <Avatar>
                <AvatarFallback>BM</AvatarFallback>
              </Avatar>
              <div className="flex-1">
                <div className="font-semibold">Billing Manager</div>
                <div className="text-sm text-muted-foreground">Approval limit: $5,000</div>
              </div>
              <Badge>Level 2</Badge>
            </div>

            {/* Property Manager */}
            <div className="ml-16 flex items-center gap-4 p-4 border rounded-lg">
              <Avatar>
                <AvatarFallback>PM</AvatarFallback>
              </Avatar>
              <div className="flex-1">
                <div className="font-semibold">Property Manager</div>
                <div className="text-sm text-muted-foreground">Approval limit: $2,000</div>
              </div>
              <Badge>Level 1</Badge>
            </div>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Approval Rules</CardTitle>
        </CardHeader>
        <CardContent>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Amount Range</TableHead>
                <TableHead>Required Approver</TableHead>
                <TableHead>SLA</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              <TableRow>
                <TableCell>$0 - $499</TableCell>
                <TableCell>Auto-approve</TableCell>
                <TableCell>Instant</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>$500 - $1,999</TableCell>
                <TableCell>Property Manager</TableCell>
                <TableCell>24 hours</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>$2,000 - $4,999</TableCell>
                <TableCell>Billing Manager</TableCell>
                <TableCell>48 hours</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>$5,000+</TableCell>
                <TableCell>Senior Manager</TableCell>
                <TableCell>72 hours</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </div>
  );
}
